import { createSelector } from '@reduxjs/toolkit';

const getPackageDataPicker = state => state.package.draft.data.dataPicker;

export const selectPackageDataCount = createSelector(getPackageDataPicker, (dataPicker) => {
    const { books, videos } = dataPicker;
    return books.length + videos.length;
});